import * as React from 'react';
import * as service from 'service';
import * as NotificationSystem from 'react-notification-system';
import * as utils from 'utils';
import { Button, Header, ThemeProvider } from 'arbina-ui';
import { connect } from 'react-redux';
import { getCurrentUser, signOut } from 'actions';
import { bindActionCreators, Dispatch } from 'redux';
import { GetCurrentUserFunction, SignOutFunction, store } from 'types';
import { withRouter } from 'react-router';
import SecuredZone from './scenes/SecuredZone';
import { SignIn } from './components/SignIn';
import { MainMenu } from './components/MainMenu';
import { Loader } from 'components';
import * as style from './style.sass';
import { ThemesCollection } from 'arbina-ui/build/types';
import * as icon from './assets/favicon.png';
import { Link } from 'react-router-dom';

const COOKIES = require('universal-cookie');

interface PropertiesShape {
  account: store.AccountShape;
}

interface DispatchShape {
  getCurrentUser: GetCurrentUserFunction;
  signOut: SignOutFunction;
}

class Application extends React.Component<PropertiesShape & DispatchShape> {
  notificationSystem: any = null;

  componentDidMount() {
    this.props.getCurrentUser();
    (window as any).notificationSystem = this.notificationSystem;
  }

  notify = (message: any) => {
    this.notificationSystem.addNotification(message);
  }

  onSignOut = () => {
    this.props.signOut();
    const cookies = new COOKIES();
    cookies.remove('token');
  }

  onSignIn = async (login: string, password: string) => {
    try {
      const response = await service.signIn(login, password);

      if (response.status === 200) {
        const cookies = new COOKIES();
        cookies.set('token', response.data.token);
        this.props.getCurrentUser();
      }
    } catch (error) {
      this.notify({
        title: 'Не удалось выполнить вход',
        message: error.response.data.description,
        level: 'error',
      });
    }
  }

  render() {
    const { account } = this.props;

    return (<div className={style.application}>
      <NotificationSystem
        ref={(n: any) => this.notificationSystem = n}
      />
      <utils.CONTEXT.Provider value={{ notify: this.notify }}>
        <ThemeProvider theme={ThemesCollection.dark}>
          {account.loading && <Loader overlay/>}
          <Header
            leftSide={<Link
              className={style.applicationTitle}
              to="/"
            >
              <img src={icon}/>
              <b>MU</b>
              <MainMenu/>
            </Link>}
            rightSide={<div>
              {account.user && <Button
                text="Exit"
                onClick={this.onSignOut}
              />}
            </div>}
          />
          <div className={style.content}>
            {account.user ?
              <SecuredZone/> :
              account.loading ?
                null :
                <SignIn
                  onSignIn={this.onSignIn}
                />}
          </div>
        </ThemeProvider>
      </utils.CONTEXT.Provider>
    </div>);
  }
}

const mapStateToProperties = (state: store.GlobalShape) => {
  return {
    account: state.account,
  };
};

const mapDispatchToProperties = (dispatch: Dispatch<any>) => bindActionCreators(
  {
    getCurrentUser,
    signOut,
  },
  dispatch);

export default withRouter<any>(connect(mapStateToProperties, mapDispatchToProperties)(Application));
